import { api } from '@/api/api-client.config.ts';
import { useMutation } from '@tanstack/react-query';

const runTournamentLeaderboardScoring = (pickemId: number) =>
  api.post(`/admin/pickems/${pickemId}/run-tournaments-leaderboard-scoring`);

export const useRunTournamentLeaderboardScoringMutation = () => {
  return useMutation({
    mutationKey: ['runTournamentLeaderboardScoring'],
    mutationFn: runTournamentLeaderboardScoring,
  });
};
